import { selectionCheckboxId } from '~/components/ui/selectionCheckbox';

export function quoteItemCheckboxId(quoteItemId: string): string {
  return selectionCheckboxId('quote-item', quoteItemId);
}
